import { Agreement, Data } from '@/connect';
import { type MaybeRefOrGetter, toValue } from '@/utils/vue';
import { ComputedRef, computed } from 'vue';

export * from './form';

export function useIsIncoming(
  agreement: MaybeRefOrGetter<Data<Agreement> | null>
): ComputedRef<boolean> {
  return computed(() => {
    const agreementValue = toValue(agreement);
    return agreementValue?.side !== agreementValue?.proposedBySide;
  });
}
